import { useFormProductVariantId } from '@/features/pos/components/ProductConfigurationModal/form'
import OptionGroup from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup'
import OptionItem from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem'
import { useUpdateProductVariant } from '@/features/pos/components/ProductConfigurationModal/parts/VariantGroup/hooks'
import { ProductVariant } from '@/features/pos/components/ProductConfigurationModal/types'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'

interface VariantGroupProps {
    productVariants: Required<ProductVariant>[]
}

const VariantGroup: FC<VariantGroupProps> = ({ productVariants }) => {
    const [productVariantId, onChange] = useFormProductVariantId()

    const updateProductVariant = useUpdateProductVariant(onChange)

    const { t } = useTranslation()

    return (
        <OptionGroup name={t('pos.optionGroup.variantSelection')} minQuantity={1} maxQuantity={1}>
            {productVariants.map((productVariant) => (
                <OptionItem
                    key={productVariant.id}
                    id={productVariant.id}
                    selected={productVariantId === productVariant.id}
                    disabled={productVariant.soldOut}
                    name={productVariant.name}
                    price={productVariant.price}
                    onPress={updateProductVariant}
                />
            ))}
        </OptionGroup>
    )
}

export default memo(VariantGroup)
